import {
  SET_CURRENT_TRAVELER,
  SEARCH_FOR_PARKING_SPOT,
} from '../constants';

import { createAction } from '../utils/redux';

export const setCurrentTraveler = createAction(
  SET_CURRENT_TRAVELER
);

export const searchForParkingSpot = createAction(
  SEARCH_FOR_PARKING_SPOT
);
